var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackcloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6271 0.375541C18.1278 0.876261 18.1278 1.68809 17.6271 2.18881L10.8146 9.0013L17.6271 15.8138C18.1278 16.3145 18.1278 17.1263 17.6271 17.6271C17.1263 18.1278 16.3145 18.1278 15.8138 17.6271L9.0013 10.8146L2.18881 17.6271C1.68809 18.1278 0.87626 18.1278 0.37554 17.6271C-0.125181 17.1263 -0.125179 16.3145 0.37554 15.8138L7.18804 9.0013L0.375541 2.18881C-0.12518 1.68809 -0.12518 0.876261 0.37554 0.375541C0.876261 -0.12518 1.68809 -0.12518 2.18881 0.37554L9.0013 7.18803L15.8138 0.37554C16.3145 -0.12518 17.1263 -0.12518 17.6271 0.375541Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackcloseIcon);
export default __webpack_public_path__ + "static/media/blackcloseIcon.b7f095729e9d39fc3ac30f2f1e299784.svg";
export { ForwardRef as ReactComponent };